/* eslint-disable @next/next/no-img-element */
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import { useSitecoreContext } from '@sitecore-jss/sitecore-jss-nextjs';
import CarouselWrapper from '../shared/Carousel/CarouselWrapper/CarouselWrapper';
import { useSelector } from 'react-redux';
import { RootState } from '../../store/store';
import {
  ExploreOpportunitiesBox,
  NoQuestionnaireBox,
  SQLableText,
} from './MyProfileQuestionnaire.style';
import UiHeading from '../shared/Heading';
import ButtonDiscreet from '../../components/shared/Button/ButtonDiscreet';
import { useRouter } from 'next/router';

const MyProfileQuestionnaireCarousel = (props: any): JSX.Element => {
  const profileData = useSelector((state: RootState) => state.crProfile?.profileData);
  const studyQuestionnaireData = profileData?.studyQuestionnaireDetails || [];
  const theme = useTheme();
  const { sitecoreContext } = useSitecoreContext();
  const isMyProfilePage = sitecoreContext?.route?.fields?.isMyProfilePage;
  const router = useRouter();

  function gotoPage(url?: string) {
    router.push({
      pathname: url,
    });
  }

  return (
    <Box
      sx={{
        backgroundColor: theme.palette.backgroundColorType3.main,
        ...(isMyProfilePage && { borderTop: `2px solid ${theme.palette.neutral3.main}` }),
      }}
      id="CR-Questionaaire-carousel"
      className="ui-cr-questionnaire-carousel"
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          padding: '48px 41px',
          maxWidth: '1400px',
          marginInline: 'auto',
          gap: '26px',
        }}
      >
        <UiHeading size="h2" align="center">
          {props?.fields?.sectionTitle}
        </UiHeading>
        {studyQuestionnaireData?.length > 0 ? (
          <CarouselWrapper
            {...props}
            questionaaireList={studyQuestionnaireData}
            callerComponent="CR-Questionaaire"
          />
        ) : (
          <NoQuestionnaireBox>
            <SQLableText>{props?.fields?.noStudyText?.value}</SQLableText>
          </NoQuestionnaireBox>
        )}
        {props?.fields?.isExploreLinkVisible?.value && (
          <ExploreOpportunitiesBox>
            <ButtonDiscreet
              onClick={() => {
                gotoPage(props?.fields?.exploreStudyLink?.value?.href || '#');
              }}
              iconRight={
                <img
                  src={props?.fields?.exploreLinkIcon?.value?.src}
                  alt={props?.fields?.exploreLinkIcon?.value?.alt}
                />
              }
            >
              {props?.fields?.exploreStudyLink?.value?.text}
            </ButtonDiscreet>
          </ExploreOpportunitiesBox>
        )}
      </Box>
    </Box>
  );
};

export default MyProfileQuestionnaireCarousel;
